import { FadeUp, Eyebrow, MaskedLines } from "./Reveal";

const CHAPTERS = [
  {
    num: "01",
    title: "Meta Advertising",
    body: "We plan, launch and manage full-funnel Meta campaigns across Facebook and Instagram — from audience research and pixel setup to ad copywriting, creative testing and daily optimisation. Budgets scale only when the numbers prove they should, and every decision is backed by a clear monthly performance report.",
    tags: ["Campaign Strategy", "Creative Testing", "Budget Scaling"],
  },
  {
    num: "02",
    title: "Premium Websites",
    body: "We design and build bespoke websites that load fast, look flawless on every device and guide visitors toward one thing: contacting you. From structure and copy placement to calls-to-action and basic SEO, every detail is shaped to turn attention into leads — and to make your company look as premium as it is.",
    tags: ["Custom Design", "Development", "SEO-Ready"],
  },
  {
    num: "03",
    title: "Brand Scaling",
    body: "Beyond campaigns and websites, we shape how your brand presents itself — positioning, creative direction and a consistent look and feel across every touchpoint. Offers are refined, content aligned and growth systems built to compound month after month, so results don't just spike — they stick.",
    tags: ["Positioning", "Creative Direction", "Growth Systems"],
  },
];

function Chapter({ ch }) {
  return (
    <div className="max-w-2xl">
      <FadeUp>
        <div className="flex items-baseline gap-5 sm:gap-6">
          <span className="ghost-number font-display text-[4rem] leading-none sm:text-[5.5rem]">
            {ch.num}
          </span>
          <h3 className="font-display text-2xl font-light tracking-tight sm:text-3xl">
            {ch.title}
          </h3>
        </div>
      </FadeUp>
      <FadeUp delay={0.1}>
        <p className="mt-4 text-sm leading-relaxed text-neutral-400">{ch.body}</p>
      </FadeUp>
      <FadeUp delay={0.18} className="mt-5 flex flex-wrap gap-2.5">
        {ch.tags.map((t) => (
          <span
            key={t}
            className="rounded-full border border-white/10 px-4 py-1.5 font-mono text-[10px] uppercase tracking-[0.18em] text-neutral-400 transition-[border-color,color] duration-300 hover:border-[#D4AF37]/50 hover:text-[#E5C158]"
          >
            {t}
          </span>
        ))}
      </FadeUp>
    </div>
  );
}

export default function Manifesto() {
  return (
    <section id="what-i-do" className="relative py-20 sm:py-24">
      <div className="mx-auto max-w-7xl px-6 sm:px-10 lg:px-16">
        <Eyebrow className="mb-6">01 — What we do</Eyebrow>
        <MaskedLines
          inView
          as="h2"
          className="max-w-3xl font-display text-2xl font-light leading-tight tracking-tight sm:text-4xl"
          lines={[
            { content: "Three disciplines." },
            { content: <span className="italic text-[#E5C158]">One obsession:</span> },
            { content: "growth." },
          ]}
        />
        <div className="mt-14 space-y-16 sm:space-y-24">
          {CHAPTERS.map((ch) => (
            <Chapter key={ch.num} ch={ch} />
          ))}
        </div>
      </div>
    </section>
  );
}